'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;



/*****************
 ** WEBPACK FOOTER
 ** ./~/get-proto/Reflect.getPrototypeOf.js
 ** module id = 438
 ** module chunks = 0
 **/